

const useTextHolder = () => {

    const COMPONENT_TYPES = { BASE: "TextHolder_Base", BG: "TextHolder_BackgroundImage" };

    const SHADOW_COLORS = {
        Light: "����",
        Dark: "���",
        Pallete: "��� �����",
    }

    const getOpacityBackground = (shadowColor: string) => {
        switch (shadowColor) {
            case SHADOW_COLORS.Light:
                return "light-opacity "
            case SHADOW_COLORS.Dark:
                return "dark-opacity "
            case SHADOW_COLORS.Pallete:
                return "bg-pallete-color-opacity "
            default:
                return ""
        }
    }

    return {
        COMPONENT_TYPES,
        SHADOW_COLORS,
        getOpacityBackground
    }
}

export default useTextHolder;
